"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _theme = require("../theme");

var _mixins = require("../utils/mixins");

var _focusSource = require("../utils/focus-source");

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

(0, _focusSource.subscribeFocusEvents)();

var styles = function styles(theme) {
  return (0, _extends3.default)({
    button: (0, _extends3.default)({
      extend: _mixins.isolateMixin,
      fontFamily: theme.button.fontFamily,
      fontStyle: theme.button.fontStyle,
      fontWeight: theme.button.fontWeight,
      letterSpacing: theme.button.letterSpacing,
      textTransform: theme.button.textTransform,
      textAlign: 'center',
      cursor: 'pointer',
      boxSizing: 'border-box',
      outline: 'none !important',
      position: 'relative',
      display: 'inline-block',
      border: 'none',
      userSelect: 'none',
      borderRadius: theme.button.borderRadius
    }, (0, _mixins.ifMobile)({
      fontWeight: theme.button.mobile.fontWeight,
      letterSpacing: theme.button.mobile.letterSpacing
    }), {
      '&, & *': {
        transition: 'background-color .2s, border .2s, box-shadow .2s'
      },
      '&:before, &:after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        pointerEvents: 'none',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        border: '1px solid transparent',
        transition: 'all .2s',
        borderRadius: theme.button.borderRadius
      },
      '&[disabled]': {
        pointerEvents: 'none'
      },
      '&::-moz-focus-inner': {
        border: 'none !important',
        outline: 'none !important'
      }
    }),
    isRounded: {
      '&$button, &:before, &:after': {
        borderRadius: '9999px !important'
      }
    },
    isLoading: {
      pointerEvents: 'none',
      opacity: 0
    },
    loader: (0, _extends3.default)({
      fontSize: 3
    }, (0, _mixins.ifMobile)({
      fontSize: 4
    })),
    content: (0, _extends3.default)({
      extend: _mixins.fontSmoothingMixin,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      position: 'relative',
      padding: '0 20px'
    }, (0, _mixins.ifMobile)({
      padding: '0 25px'
    })),
    block: {
      display: 'block',
      width: '100%'
    },
    'size-medium': (0, _extends3.default)({
      fontSize: theme.button.sizes.medium.fontSize
    }, (0, _mixins.ifMobile)({
      fontSize: theme.button.mobile.sizes.medium.fontSize
    }), {
      '& $content': (0, _extends3.default)({
        height: theme.button.sizes.medium.height,
        lineHeight: theme.button.sizes.medium.height + 'px'
      }, (0, _mixins.ifMobile)({
        height: theme.button.mobile.sizes.medium.height,
        lineHeight: theme.button.mobile.sizes.medium.height + 'px'
      }))
    }),
    'size-small': (0, _extends3.default)({
      fontSize: theme.button.sizes.small.fontSize
    }, (0, _mixins.ifMobile)({
      fontSize: theme.button.mobile.sizes.small.fontSize
    }), {
      '& $content': (0, _extends3.default)({
        height: theme.button.sizes.small.height,
        lineHeight: theme.button.sizes.small.height + 'px'
      }, (0, _mixins.ifMobile)({
        height: theme.button.mobile.sizes.small.height,
        lineHeight: theme.button.mobile.sizes.small.height + 'px'
      }))
    }),
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      opacity: 0,
      width: '100%',
      height: '100%',
      cursor: 'pointer'
    },
    icon: {
      display: 'inline-block',
      transition: 'fill .2s'
    },
    'iconPosition-right': {
      '& $icon': (0, _extends3.default)({
        marginLeft: 5
      }, (0, _mixins.ifMobile)({
        marginLeft: 10
      }))
    },
    'iconPosition-left': {
      '& $icon': (0, _extends3.default)({
        marginRight: 5
      }, (0, _mixins.ifMobile)({
        marginRight: 10
      }))
    }
  }, ['primary', 'secondary', 'outline', 'flat', 'danger'].reduce(function (result, type) {
    var conf = theme.button.types[type];
    var offset = conf.outlineOffset || 0;

    var setThemeForSelector = function setThemeForSelector(colors, outlineOffset, textDecoration) {
      return (0, _extends3.default)({
        background: colors.background
      }, textDecoration && {
        textDecoration: textDecoration
      }, {
        '&, & *': {
          color: colors.text
        },
        '&:before': (0, _extends3.default)({}, colors.border && {
          borderColor: colors.border
        }),
        '&:after': (0, _extends3.default)({}, colors.outline && {
          left: -outlineOffset,
          right: -outlineOffset,
          top: -outlineOffset,
          bottom: -outlineOffset,
          borderColor: colors.outline,
          borderRadius: theme.button.borderRadius + outlineOffset / 1.5
        }),
        '& $icon': {
          fill: colors.icon
        }
      });
    };

    return (0, _extends3.default)({}, result, (0, _defineProperty2.default)({}, "type-".concat(type), (0, _extends3.default)({
      '&:active:active': setThemeForSelector(conf.colors.active, offset),
      '&:hover': setThemeForSelector(conf.colors.hover, offset, conf.hover.textDecoration),
      '&[disabled]': setThemeForSelector(conf.colors.disabled, offset)
    }, (0, _mixins.focusSourceMixin)('other', '&:focus', setThemeForSelector(conf.colors.focus, offset)), {}, setThemeForSelector(conf.colors.default, offset, conf.textDecoration), {
      '& $loader': {
        color: conf.colors.default.loader
      }
    })));
  }, {}));
};

var Button = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Button, _PureComponent);

  var _super = _createSuper(Button);

  function Button() {
    (0, _classCallCheck2.default)(this, Button);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Button, [{
    key: "renderIcon",
    value: function renderIcon(icon) {
      if (icon) {
        var _this$props = this.props,
            theme = _this$props.theme,
            size = _this$props.size,
            classes = _this$props.classes;
        var iconProps = {
          size: theme.button.sizes[size].icon,
          color: null
        };
        var initialProps = icon.props || {};
        var className = (0, _classnames.default)(initialProps.className, classes.icon);
        var resultProps = (0, _extends3.default)({}, iconProps, {}, initialProps, {
          className: className
        });
        return (0, _react.cloneElement)(icon, resultProps);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          icon = _this$props2.icon,
          children = _this$props2.children,
          size = _this$props2.size,
          type = _this$props2.type,
          container = _this$props2.container,
          buttonType = _this$props2.buttonType,
          disabled = _this$props2.disabled,
          loading = _this$props2.loading,
          block = _this$props2.block,
          className = _this$props2.className,
          overlay = _this$props2.overlay,
          width = _this$props2.width,
          iconPosition = _this$props2.iconPosition,
          rounded = _this$props2.rounded,
          _this$props2$style = _this$props2.style,
          style = _this$props2$style === void 0 ? {} : _this$props2$style,
          nodeRef = _this$props2.nodeRef,
          classes = _this$props2.classes,
          theme = _this$props2.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["icon", "children", "size", "type", "container", "buttonType", "disabled", "loading", "block", "className", "overlay", "width", "iconPosition", "rounded", "style", "nodeRef", "classes", "theme"]);
      var iconLeft = iconPosition === 'left';
      var iconEl = this.renderIcon(icon);
      var resultStyle = (0, _extends3.default)({
        width: width
      }, style);
      var resultClassName = (0, _classnames.default)(classes.button, classes["type-".concat(type)], classes["size-".concat(size)], classes["iconPosition-".concat(iconPosition)], className, rounded && classes.isRounded, block && classes.block);

      var resultChildren = _react.default.createElement("span", {
        className: (0, _classnames.default)(classes.content, loading && classes.isLoading)
      }, iconLeft && iconEl, children, !iconLeft && iconEl, overlay && (0, _react.cloneElement)(overlay, {
        className: classes.overlay
      }));

      var resultProps = (0, _extends3.default)({}, other, {
        style: resultStyle,
        className: resultClassName,
        disabled: disabled ? 'disabled' : null
      });
      var resultContainer = (0, _react.isValidElement)(container) ? container : overlay ? _react.default.createElement("div", {
        ref: nodeRef
      }) : _react.default.createElement("button", {
        type: buttonType,
        ref: nodeRef
      });
      return (0, _react.cloneElement)(resultContainer, resultProps, resultChildren, loading && _react.default.createElement(_Spinner.default, {
        className: classes.loader,
        color: null
      }));
    }
  }]);
  return Button;
}(_react.PureComponent);

Button.defaultProps = {
  type: 'primary',
  size: 'medium',
  buttonType: 'button',
  iconPosition: 'left',
  block: false
};
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Тип стиля кнопки
   */
  type: _propTypes.default.oneOf(['primary', 'secondary', 'outline', 'flat', 'danger']),

  /**
   * Css-класс
   */
  className: _propTypes.default.string,

  /**
   * Inline-стили
   */
  style: _propTypes.default.object,

  /**
   * Контент для кнопки
   */
  children: _propTypes.default.node,

  /**
   * Иконка для кнопки
   */
  icon: _propTypes.default.node,

  /**
   * Позиция иконки: слева/справа
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Размер кнопки
   */
  size: _propTypes.default.oneOf(['small', 'medium']),

  /**
   * Элемент, который содержит контент, например `<Link />`
   * в случае с `react-router`
   */
  container: _propTypes.default.element,

  /**
   * Элемент, который прозрачно накладывается на кнопку (Например `<input type="file" />`)
   */
  overlay: _propTypes.default.element,

  /**
   * Отключаем кнопку/ссылку
   */
  disabled: _propTypes.default.bool,

  /**
   * Отображать кнопку как блочный элемент
   */
  block: _propTypes.default.bool,

  /**
   * Тип кнопки
   */
  buttonType: _propTypes.default.string,

  /**
   * Ширина кнопки
   */
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Показывать индикатор загрузки
   */
  loading: _propTypes.default.bool,

  /**
   * Закругленная кнопка
   */
  rounded: _propTypes.default.bool,

  /**
   * Коллбэк для передачи ссылки на ноду элемента кнопки
   */
  nodeRef: _propTypes.default.func
} : {};

var _default = (0, _theme.withStyles)(styles, {
  name: 'Button'
})(Button);

exports.default = _default;